import { Pagination } from '@lsq-frontend/angular-shared/api-service';
import { InvoiceSummary2 } from './models';

export class ListInvoiceSummaryForBuyerResponse {
    public ok = false;
    public rows: InvoiceSummary2[] = [];
    public error: Error = null;
    public pagination = new Pagination();
    public totalCount = 0;
    public totalCountBuyerInvoices = 0;

    public constructor(init?: Partial<ListInvoiceSummaryForBuyerResponse>) {
        Object.keys(init ?? {}).forEach((k) => (this[k] = init[k]));
    }
}
